import { storeToRefs } from 'pinia'
import type { ProductPlatformKeys } from '~/server/type'

export const useProductLogic = (platform: ProductPlatformKeys | '') => {
	const { getProductsByCategory, ...productStore } = storeToRefs(useProductsStore())
	const allProduct = computed(() => {
		if (platform === 'diaspora') {
			return productStore.diasporaProducts.value
		} else if (platform === 'individual') {
			return productStore.individualProducts.value
		} else {
			return productStore.allProducts.value
		}
	})
	const getProductsByProductName = computed(() => {
		if (platform === 'diaspora') {
			return productStore.getDiasporaProductsByName.value
		} else if (platform === 'individual') {
			return productStore.getIndividualProductsByName.value
		} else {
			return productStore.getProductsByProductName.value
		}
	})

	return {
		allProduct,
		getProductsByProductName,
		getProductsByCategory
	}
}
